/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CategoryModel,
  CreateCategoryPayload,
  DeleteCategoryPayload,
  GetCategoryPayload,
  GetCustomCategoriesParams,
  GetCustomCategoryResponse,
  GetRoiTaxonomyParams,
  HTTPValidationError,
  MoveCategoriesPayload,
  MoveCategoryPayload,
  MoveInteractionsPayload,
  ROITaxonomyResponse,
  UpdateCategoryPayload,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCategoryUrl = () => {
  return `/api/v1/category/get-category`;
};

/**
 * @summary Get Category
 */
export const getCategory = async (
  getCategoryPayload: GetCategoryPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<CategoryModel> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CategoryModel>(getGetCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getCategoryPayload),
  });
};

export const getGetCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCategory>>,
    TError,
    GetCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof getCategory>>, TError, GetCategoryMutationVariables, TContext> => {
  const mutationKey = ['getCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCategory>>, GetCategoryMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return getCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof getCategory>>>;
export type GetCategoryMutationBody = GetCategoryPayload;
export type GetCategoryMutationError = HTTPValidationError;
export type GetCategoryMutationVariables = { data: GetCategoryPayload };

/**
 * @summary Get Category
 */
export const useGetCategory = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCategory>>,
    TError,
    GetCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof getCategory>>, TError, GetCategoryMutationVariables, TContext> => {
  return useMutation(getGetCategoryMutationOptions(options));
};
export const getGetCustomCategoriesUrl = (params: GetCustomCategoriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/category/get-custom-categories?${stringifiedParams}`
    : `/api/v1/category/get-custom-categories`;
};

/**
 * @summary Get Categories
 */
export const getCustomCategories = async (
  params: GetCustomCategoriesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCustomCategoryResponse> => {
  return customFetch<GetCustomCategoryResponse>(getGetCustomCategoriesUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetCustomCategoriesQueryKey = (params?: GetCustomCategoriesParams) => {
  return [`/api/v1/category/get-custom-categories`, ...(params ? [params] : [])] as const;
};

export const getGetCustomCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomCategories>>,
  TError = HTTPValidationError,
>(
  params: GetCustomCategoriesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomCategories>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomCategoriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomCategories>>> = ({ signal }) =>
    getCustomCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomCategories>>>;
export type GetCustomCategoriesQueryError = HTTPValidationError;

/**
 * @summary Get Categories
 */

export function useGetCustomCategories<
  TData = Awaited<ReturnType<typeof getCustomCategories>>,
  TError = HTTPValidationError,
>(
  params: GetCustomCategoriesParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getCustomCategories>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMoveCategoryUrl = () => {
  return `/api/v1/category/move-category`;
};

/**
 * @summary Move Category
 */
export const moveCategory = async (
  moveCategoryPayload: MoveCategoryPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getMoveCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveCategoryPayload),
  });
};

export const getMoveCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveCategory>>,
    TError,
    MoveCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof moveCategory>>, TError, MoveCategoryMutationVariables, TContext> => {
  const mutationKey = ['moveCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveCategory>>, MoveCategoryMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return moveCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof moveCategory>>>;
export type MoveCategoryMutationBody = MoveCategoryPayload;
export type MoveCategoryMutationError = HTTPValidationError;
export type MoveCategoryMutationVariables = { data: MoveCategoryPayload };

/**
 * @summary Move Category
 */
export const useMoveCategory = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveCategory>>,
    TError,
    MoveCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof moveCategory>>, TError, MoveCategoryMutationVariables, TContext> => {
  return useMutation(getMoveCategoryMutationOptions(options));
};
export const getMoveCategoriesUrl = () => {
  return `/api/v1/category/move-categories`;
};

/**
 * @summary Move Categories
 */
export const moveCategories = async (
  moveCategoriesPayload: MoveCategoriesPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getMoveCategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveCategoriesPayload),
  });
};

export const getMoveCategoriesMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveCategories>>,
    TError,
    MoveCategoriesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveCategories>>,
  TError,
  MoveCategoriesMutationVariables,
  TContext
> => {
  const mutationKey = ['moveCategories'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveCategories>>, MoveCategoriesMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return moveCategories(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof moveCategories>>>;
export type MoveCategoriesMutationBody = MoveCategoriesPayload;
export type MoveCategoriesMutationError = HTTPValidationError;
export type MoveCategoriesMutationVariables = { data: MoveCategoriesPayload };

/**
 * @summary Move Categories
 */
export const useMoveCategories = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveCategories>>,
    TError,
    MoveCategoriesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof moveCategories>>,
  TError,
  MoveCategoriesMutationVariables,
  TContext
> => {
  return useMutation(getMoveCategoriesMutationOptions(options));
};
export const getMoveInteractionsUrl = () => {
  return `/api/v1/category/move-interactions`;
};

/**
 * @summary Move Interactions
 */
export const moveInteractions = async (
  moveInteractionsPayload: MoveInteractionsPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getMoveInteractionsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveInteractionsPayload),
  });
};

export const getMoveInteractionsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveInteractions>>,
    TError,
    MoveInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveInteractions>>,
  TError,
  MoveInteractionsMutationVariables,
  TContext
> => {
  const mutationKey = ['moveInteractions'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveInteractions>>,
    MoveInteractionsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return moveInteractions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveInteractionsMutationResult = NonNullable<Awaited<ReturnType<typeof moveInteractions>>>;
export type MoveInteractionsMutationBody = MoveInteractionsPayload;
export type MoveInteractionsMutationError = HTTPValidationError;
export type MoveInteractionsMutationVariables = { data: MoveInteractionsPayload };

/**
 * @summary Move Interactions
 */
export const useMoveInteractions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveInteractions>>,
    TError,
    MoveInteractionsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof moveInteractions>>,
  TError,
  MoveInteractionsMutationVariables,
  TContext
> => {
  return useMutation(getMoveInteractionsMutationOptions(options));
};
export const getCreateCategoryUrl = () => {
  return `/api/v1/category/create-category`;
};

/**
 * @summary Create Category
 */
export const createCategory = async (
  createCategoryPayload: CreateCategoryPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getCreateCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCategoryPayload),
  });
};

export const getCreateCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    CreateCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  CreateCategoryMutationVariables,
  TContext
> => {
  const mutationKey = ['createCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCategory>>, CreateCategoryMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createCategory>>>;
export type CreateCategoryMutationBody = CreateCategoryPayload;
export type CreateCategoryMutationError = HTTPValidationError;
export type CreateCategoryMutationVariables = { data: CreateCategoryPayload };

/**
 * @summary Create Category
 */
export const useCreateCategory = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCategory>>,
    TError,
    CreateCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCategory>>,
  TError,
  CreateCategoryMutationVariables,
  TContext
> => {
  return useMutation(getCreateCategoryMutationOptions(options));
};
export const getGetRoiTaxonomyUrl = (params: GetRoiTaxonomyParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/category/roi-taxonomy?${stringifiedParams}`
    : `/api/v1/category/roi-taxonomy`;
};

/**
 * @summary Get Roi Taxonomy
 */
export const getRoiTaxonomy = async (
  params: GetRoiTaxonomyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ROITaxonomyResponse> => {
  return customFetch<ROITaxonomyResponse>(getGetRoiTaxonomyUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetRoiTaxonomyQueryKey = (params?: GetRoiTaxonomyParams) => {
  return [`/api/v1/category/roi-taxonomy`, ...(params ? [params] : [])] as const;
};

export const getGetRoiTaxonomyQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoiTaxonomy>>,
  TError = HTTPValidationError,
>(
  params: GetRoiTaxonomyParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRoiTaxonomy>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRoiTaxonomyQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoiTaxonomy>>> = ({ signal }) =>
    getRoiTaxonomy(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoiTaxonomy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRoiTaxonomyQueryResult = NonNullable<Awaited<ReturnType<typeof getRoiTaxonomy>>>;
export type GetRoiTaxonomyQueryError = HTTPValidationError;

/**
 * @summary Get Roi Taxonomy
 */

export function useGetRoiTaxonomy<TData = Awaited<ReturnType<typeof getRoiTaxonomy>>, TError = HTTPValidationError>(
  params: GetRoiTaxonomyParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getRoiTaxonomy>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRoiTaxonomyQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateCategoryUrl = () => {
  return `/api/v1/category/update-category`;
};

/**
 * @summary Update Category
 */
export const updateCategory = async (
  updateCategoryPayload: UpdateCategoryPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getUpdateCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCategoryPayload),
  });
};

export const getUpdateCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    UpdateCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  UpdateCategoryMutationVariables,
  TContext
> => {
  const mutationKey = ['updateCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategory>>, UpdateCategoryMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return updateCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategory>>>;
export type UpdateCategoryMutationBody = UpdateCategoryPayload;
export type UpdateCategoryMutationError = HTTPValidationError;
export type UpdateCategoryMutationVariables = { data: UpdateCategoryPayload };

/**
 * @summary Update Category
 */
export const useUpdateCategory = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCategory>>,
    TError,
    UpdateCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCategory>>,
  TError,
  UpdateCategoryMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCategoryMutationOptions(options));
};
export const getDeleteCategoryUrl = () => {
  return `/api/v1/category/delete-category`;
};

/**
 * @summary Delete Category
 */
export const deleteCategory = async (
  deleteCategoryPayload: DeleteCategoryPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getDeleteCategoryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteCategoryPayload),
  });
};

export const getDeleteCategoryMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    DeleteCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  DeleteCategoryMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteCategory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategory>>, DeleteCategoryMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return deleteCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategory>>>;
export type DeleteCategoryMutationBody = DeleteCategoryPayload;
export type DeleteCategoryMutationError = HTTPValidationError;
export type DeleteCategoryMutationVariables = { data: DeleteCategoryPayload };

/**
 * @summary Delete Category
 */
export const useDeleteCategory = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    DeleteCategoryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  DeleteCategoryMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCategoryMutationOptions(options));
};
